import { ChangeableParticleAttributes } from './types'

export const defaultGravityMultiplier = 1
export const defaultTimeScaleFactor = 1

export const defaultBackgroundColor = '#abccd3'

export const defaultParticleSettings: ChangeableParticleAttributes = {
  nrOfParticles: 150,
  lifespan: { value: 600, randomness: 10 },
  color: {
    value: '#00aaff',
    randomness: 10
  },
  bounciness: { value: 0.75, randomness: 0 },
  radius: { value: 10, randomness: 50 }
}

export const defaultCellSize = 200